// extracted by mini-css-extract-plugin
module.exports = {"searchCollapse":"_2qhXlyC8RPXulBcA8412RB"};